import { GraphQLFloat, GraphQLList, GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql';
import { TypeNames } from '../../types';
var ContainerDetails = new GraphQLObjectType({
  fields: {
    id: {
      type: new GraphQLNonNull(GraphQLString)
    },
    key: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    },
    url: {
      type: GraphQLString
    },
    iconUrl: {
      type: GraphQLString
    }
  },
  name: TypeNames.CONTAINER_DETAILS
});
var Container = new GraphQLObjectType({
  fields: {
    id: {
      type: new GraphQLNonNull(GraphQLString)
    },
    entityType: {
      type: new GraphQLNonNull(GraphQLString)
    },
    containerType: {
      type: new GraphQLNonNull(GraphQLString)
    },
    score: {
      type: new GraphQLNonNull(GraphQLFloat)
    },
    containerDetails: {
      type: ContainerDetails
    }
  },
  name: TypeNames.CONTAINER
});
var Containers = new GraphQLObjectType({
  fields: {
    collaborationGraphEntities: {
      type: new GraphQLNonNull(new GraphQLList(new GraphQLNonNull(Container)))
    }
  },
  name: TypeNames.CONTAINERS,
  description: 'A list of Places Spaces/Projects'
});
export default Containers;